<template>
    <div>
        <div class="icon-card-set-wrapper">
            <section v-for="event in active" class="icon-card-wrapper">
                <div class="icon-card has-no-hover">
                    <header class="icon-card-header">
                        <div class="card-badge">
                            <p class="date-badge">
                                <span class="sr-only">Date:</span>
                                <span class="month" :aria-label="event.occurence.toLocaleDateString('en-US', {
                                    month: 'long'
                                })">
                                    {{ event.occurence.toLocaleDateString('en-US', {
                                        month: 'short'
                                    }) }}
                                </span>
                                <span class="day">
                                    {{ event.occurence.toLocaleDateString('en-US', {
                                        day: 'numeric'
                                    }) }}
                                </span>
                            </p>
                        </div>
                        <div class="card-title-block">
                            <h3 class="card-title">{{ event.title }}</h3>
                        </div>
                    </header>
                    <div class="card-top">
                        <div class="card-content">
                            <p class="event-card-location">
                                <span class="fee">
                                    <span v-if="event.has_free && event.is_free" class="free">Free</span>
                                    <span v-else-if="event.has_free && !event.is_free" class="free">Free Option</span>
                                    <span v-else="event.price_range !== ''">{{ event.price_range }}</span>
                                </span>
                            </p>
                            <p class="event-card-location">
                                <template v-if="event.timeDescription">
                                    {{ event.timeDescription }}
                                </template>
                                <template v-else>
                                    {{ event.eventTime.length ? event.eventTime.join(' - ') : 'All Day' }} <br>
                                    <span v-if="event.recurrences.length" class="font-italic">
                                        <template v-for="rule, i in event.recurrences">
                                            {{ uppercaseFirst(rule) }}
                                            {{ (i + 1) !== event.recurrences.length ? '|' : '' }}
                                        </template>
                                    </span>
                                </template>
                            </p>
                            <p v-if="event.virtual" class="event-card-location">
                                Virtual <br>
                                <span v-if="event.virtualType" class="font-italic">
                                    {{ event.virtualType }}
                                </span>
                            </p>
                            <p v-if="event.location" class="event-card-location">
                                {{ event.location.name }}
                                <template v-if="event.location.city">
                                    <br>
                                    <span class="font-italic">
                                        {{ event.location.city }}
                                    </span>
                                </template>
                            </p>
                        </div>
                    </div>

                    <div class="calendar-button card-action">
                        <div title="Add to Calendar" class="addeventatc btn btn10 sml">
                            Add to Calendar
                            <span class="start">
                                {{ event.occurence.toLocaleDateString('en-US') }}
                                {{ event.eventTime[0] }}
                            </span>
                            <span class="end">
                                {{ event.occurence.toLocaleDateString('en-US') }}
                                {{ event.eventTime[1] }}
                            </span>
                            <span class="timezone">America/Chicago</span>
                            <span class="title">{{ event.title }}</span>
                            <span class="description">{{ event.description }}<br><br>{{ event.url }}</span>
                            <span v-if="event.location" class="location">
                                {{ event.location.name }}
                                {{ event.location.address1 }}
                                {{ event.location.address2 }}
                                <template v-if="event.subTitle">
                                    - {{ event.subTitle }}
                                </template>
                            </span>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div v-if="pages > page" class="button-wrapper">
            <button @click="() => page++" class="btn med rad btn01">
                Load More
            </button>
        </div>
    </div>
</template>

<script>
    import { nextTick } from 'vue'

    export default {
        data() {
            return {
                itemsPerLoad: 6,
                details: '',
                occurences: [],
                events: [],
                pages: 0,
                page: 0
            };
        },
        mounted() {
            this.details = JSON.parse(window['event-details'].textContent);
            this.occurences = JSON.parse(window['event-occurences'].textContent);
            this.events = this.occurences.map(occurence => ({ ...this.details, occurence: new Date(occurence) }));
            this.pages = (this.events.length / this.itemsPerLoad) - 1;
        },
        watch: {
            page: {
                handler(value) {
                    nextTick().then(() => window.addeventatc.refresh());
                }
            }
        },
        computed: {
            active() {
                return this.events.slice(0, this.page * (this.itemsPerLoad || 0) + (this.itemsPerLoad || this.events.length));
            }
        },
        methods: {
            uppercaseFirst(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        }
    };
</script>

<style>
    .button-wrapper {
        margin-top: 3rem;
        margin-bottom: 0;
        text-align: center;
    }
</style>
